import * as React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Typography, useTheme } from "@mui/material"

export default function FollowUp({ rows, perfectWeeks, currentDay }) {

  const theme = useTheme();
  const reducirEnEscala = (numero) => {
    if (numero <= 5) return numero;
    return ((numero - 1) % 5) + 1;
  }
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "80vh", 
        overflow: "hidden", 
      }}
    >
      <Box
        sx={{
          flex: "0 0 80%", 
          overflow: "hidden", 
          p: 2,
        }}
      >
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            height: "100%", 
            overflow: "auto",
          }}
        >
          <Table stickyHeader aria-label="tabla de seguimiento">
            <TableHead>
              <TableRow sx={{ "& th": { fontWeight: "bold", color: "#333", backgroundColor: "#fff", zIndex: 1 } }}>
                <TableCell>FECHA</TableCell>
                <TableCell>SEMANA</TableCell>
                <TableCell>DÍA</TableCell>
                <TableCell>DESCRIPCIÓN</TableCell>
                <TableCell>VELOCIDAD P/M</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell>{row.fecha}</TableCell>
                  <TableCell>{row.semana}</TableCell>
                  <TableCell>{row.dia}</TableCell>
                  <TableCell>{row.descripcion}</TableCell>
                  <TableCell>{row.velocidad}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box
        sx={{
          flex: "0 0 20%", // Ocupa el 20% restante
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          p: 2,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", px: 2 }}>
          <Box>
            <Typography variant="subtitle1" component="span">
              Semanas perfectas
            </Typography>
            <Typography variant="subtitle1" component="span" color="primary" fontWeight="bold" sx={{ ml: 1 }}>
              {perfectWeeks}
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" component="span">
              Actual
            </Typography>
            <Box component="span" sx={{ display: "inline-flex", ml: 1 }}>
              {[1, 2, 3, 4, 5].map((dot, index) => (
                <Box
                  key={dot}
                  component="span"
                  sx={{
                    display: "inline-block",
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: index < reducirEnEscala(currentDay) ? theme.palette.primary.main : "#e0e0e0",
                    mx: 0.5,
                  }}
                />
              ))}
            </Box>
          </Box>
        </Box>

        
      </Box>
    </Box>
  )
}
